import { decode } from 'html-entities';

export const utilDecodeHtmlEntities = (text: unknown): string => {
  if (text == null) return '';

  const textStr = decode(String(text));

  return textStr;
};
